import { ApolloLink } from "./ApolloLink.js";
export var concat = ApolloLink.concat;
//# sourceMappingURL=concat.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/link/core/concat.js
// module id = 1492
// module chunks = 4